function VideoPlayIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill="#292D32"
        className="fill"
      />
      <path
        d="M21.48 7.86011H2.52002C2.11002 7.86011 1.77002 7.52011 1.77002 7.11011C1.77002 6.70011 2.10002 6.36011 2.52002 6.36011H21.48C21.89 6.36011 22.23 6.70011 22.23 7.11011C22.23 7.52011 21.9 7.86011 21.48 7.86011Z"
        fill="#292D32"
        className="fill"
      />
      <path
        d="M8.52002 7.72011C8.11002 7.72011 7.77002 7.38011 7.77002 6.97011V2.11011C7.77002 1.70011 8.11002 1.36011 8.52002 1.36011C8.93002 1.36011 9.27002 1.70011 9.27002 2.11011V6.97011C9.27002 7.38011 8.93002 7.72011 8.52002 7.72011Z"
        fill="#292D32"
        className="fill"
      />
      <path
        d="M15.48 7.27011C15.07 7.27011 14.73 6.93011 14.73 6.52011V2.11011C14.73 1.70011 15.07 1.36011 15.48 1.36011C15.89 1.36011 16.23 1.70011 16.23 2.11011V6.52011C16.23 6.94011 15.9 7.27011 15.48 7.27011Z"
        fill="#292D32"
        className="fill"
      />
      <path
        d="M11.09 18.12C10.73 18.12 10.39 18.03 10.08 17.86C9.4 17.46 9 16.66 9 15.65V13.25C9 12.24 9.4 11.43 10.09 11.03C10.78 10.63 11.68 10.69 12.55 11.2L14.63 12.4C15.5 12.9 16.01 13.65 16.01 14.45C16.01 15.25 15.5 16 14.62 16.5L12.54 17.7C12.06 17.98 11.56 18.12 11.09 18.12ZM11.1 12.27C11 12.27 10.91 12.29 10.84 12.33C10.63 12.45 10.5 12.79 10.5 13.25V15.65C10.5 16.1 10.63 16.44 10.84 16.57C11.05 16.69 11.41 16.63 11.8 16.4L13.88 15.2C14.27 14.97 14.51 14.69 14.51 14.45C14.51 14.21 14.28 13.93 13.88 13.7L11.8 12.5C11.54 12.35 11.29 12.27 11.1 12.27Z"
        fill="#292D32"
        className="fill"
      />
    </svg>
  );
}

export default VideoPlayIcon;
